import { cookieStorage } from '@muse-web/storages'
import { DEVICE_ID_KEY, EXPERIMENT_MEMBER_COOKIE_NAME } from '../constants/cookieKeys'
import { getSessionFromLocalStorage } from './clientSession'
import { readSessionId } from './sessionId'

export const setClientHeaders = (request: Request) => {
    const deviceId = cookieStorage.get(DEVICE_ID_KEY)
    const session = getSessionFromLocalStorage()
    const experimentMemberId = cookieStorage.get(EXPERIMENT_MEMBER_COOKIE_NAME)

    if (session) {
        request.headers.set(
            'Authorization',
            `${session.token.tokenType} ${session.token.accessToken}`,
        )
    } else {
        request.headers.delete('Authorization')
    }

    request.headers.set(
        'x-analytics-context',
        JSON.stringify({
            device_id: Number(deviceId),
            // The backend casts a missing session_id to 0, so this field must always be present.
            session_id: Number(readSessionId()),
            member_experiment_id: Number(experimentMemberId),
        }),
    )
}
